import {getAttr} from "@/js/ant/end.js";

// 修改商品不同商品不同参数
export function objWind(pitem, item, nRate, rooms, arrFloor, arr) {
    let oGoodsInfo = {};
    if (pitem.system_id == 1) {
        let nPower = "";
        if (item.new_goods_type_id == 200) {
            if (nRate) {
                nPower = pitem.power * (nRate / 100);
            } else {
                nPower = pitem.power;
            }
        }
        oGoodsInfo = {
            system_id: pitem.system_id, //商品一级分类
            goods_type_id: item.new_goods_type_id, //商品二级分类id
            arrWind: JSON.parse(JSON.stringify(arr)), //商品
            bFloor: true, //是否需要选择楼层
            nFloor: rooms,
            arrFloor: arrFloor, //楼层
            power: item.new_goods_type_id == 200 ? nPower : 0, //风盘总功率
        };
    } else if (pitem.system_id == 2) {
        oGoodsInfo = {
            system_id: pitem.system_id, //商品一级分类
            goods_type_id: item.new_goods_type_id, //商品二级分类id
            arrWind: JSON.parse(JSON.stringify(arr)), //商品
            bFloor: true, //是否需要选择楼层
            nFloor: rooms,
            arrFloor: arrFloor, //楼层
            water_energy: pitem.water_energy, //热水负荷
        };
    } else if (pitem.system_id == 3) {
        oGoodsInfo = {
            system_id: pitem.system_id, //商品一级分类
            goods_type_id: item.new_goods_type_id, //商品二级分类id
            arrWind: JSON.parse(JSON.stringify(arr)), //商品
            bFloor: true, //是否需要选择楼层
            nFloor: rooms,
            arrFloor: arrFloor, //楼层
            wind_energy: pitem.wind_energy * pitem.wind_exchange, //风量
        };
    } else if (pitem.system_id == 4) {
        oGoodsInfo = {
            system_id: pitem.system_id, //商品一级分类
            goods_type_id: item.new_goods_type_id, //商品二级分类id
            arrWind: JSON.parse(JSON.stringify(arr)), //商品
            bFloor: true, //是否需要选择楼层
            nFloor: rooms,
            arrFloor: arrFloor, //楼层
            water_clean: pitem.water_clean, //净水用量
            water_soft: pitem.water_soft, //软水用量
        };
    } else if (pitem.system_id == 5) {
        oGoodsInfo = {
            system_id: pitem.system_id, //商品一级分类
            goods_type_id: item.new_goods_type_id, //商品二级分类id
            arrWind: JSON.parse(JSON.stringify(arr)), //商品
            bFloor: true, //是否需要选择楼层
            nFloor: rooms,
            arrFloor: arrFloor, //楼层
        };
    }
    return oGoodsInfo
}

/*
    * 初始化选型商品
*/
export function model(bChangeRate, bChangeWind, objModel, arrPre, nRate, arrPower, bHotWaterFlow, nWaterRate) {
    objModel.forEach((it, pindex) => {
        if ((bChangeRate || bChangeWind || bHotWaterFlow)) {
            //给每层楼添加默认同开率
            it.nPower =
                arrPower[pindex].power < 30
                    ? "30"
                    : arrPower[pindex].power.toFixed(0);


        }
        it.product.forEach((pit, cindex) => {
            let arrGoods = [];
            if (bChangeRate || bChangeWind || bHotWaterFlow) {
                // 初始化商品
                pit.items.forEach((cit) => {
                    if (cit.items.length) {
                        getAttr(cit.items)
                        cit.items.forEach((git) => {
                            arrGoods.push(git);
                        });
                    }
                });
                pit.arrGoods = arrGoods;
                if (pit.system_id == 1) {
                    pit.energy_cold_js =
                        it.energy_cold * (nRate / 100);
                    pit.energy_hot_js =
                        it.energy_hot * (nRate / 100);
                    if (arrPre[pindex].product[cindex]) {
                        arrPre[pindex].product[
                            cindex
                            ].energy_cold_js = pit.energy_cold_js;
                        arrPre[pindex].product[
                            cindex
                            ].energy_hot_js = pit.energy_hot_js;
                        arrPre[pindex].product[
                            cindex
                            ].arrGoods = pit.arrGoods;
                    }
                }
                if (pit.system_id == 3) {
                    pit.wind_exchange = it.wind_exchange;
                    pit.wind_area = it.wind_area;
                    pit.wind_energy = it.wind_energy;
                    if (arrPre[pindex].product[cindex]) {
                        arrPre[pindex].product[
                            cindex
                            ].wind_exchange = pit.wind_exchange;
                        arrPre[pindex].product[
                            cindex
                            ].wind_area = pit.wind_area;
                        arrPre[pindex].product[
                            cindex
                            ].wind_energy = pit.wind_energy;
                        arrPre[pindex].product[
                            cindex
                            ].arrGoods = pit.arrGoods;
                    }
                }
                /* 修改热水设计流量的话，只修改system_id=2的系统分类下的商品 */
                if (pit.system_id == 2) {
                    pit.water_cold = it.water_cold;
                    pit.water_rate = nWaterRate;
                    pit.water_energy = it.water_energy;
                    if (arrPre[pindex].product[cindex]) {
                        arrPre[pindex].product[
                            cindex
                            ].water_cold = pit.water_cold;
                        arrPre[pindex].product[
                            cindex
                            ].water_rate = pit.water_rate;
                        arrPre[pindex].product[
                            cindex
                            ].water_energy = pit.water_energy;
                        arrPre[pindex].product[
                            cindex
                            ].arrGoods = pit.arrGoods;
                    }
                }
            } else {
                if (pit.system_id == 1) {
                    pit.energy_cold_area = it.energy_cold_area;
                    pit.temperature = it.temperature_design;
                    pit.energy_cold = it.energy_cold;
                    pit.energy_hot = it.energy_hot;
                    pit.energy_cold_js = it.energy_cold;
                    pit.energy_hot_js = it.energy_hot;
                    pit.power = it.power;
                } else if (pit.system_id == 2) {
                    pit.water_cold = it.water_cold;
                    pit.water_rate = it.water_rate;
                    pit.water_energy = it.water_energy;
                } else if (pit.system_id == 3) {
                    pit.wind_exchange = it.wind_exchange;
                    pit.wind_area = it.wind_area;
                    pit.wind_energy = it.wind_energy;
                } else if (pit.system_id == 4) {
                    pit.water_clean = it.water_clean;
                    pit.water_soft = it.water_soft;
                }
                pit.rate = nRate;
                pit.items.forEach((cit) => {
                    if (cit.items.length) {
                        getAttr(cit.items)
                        cit.items.forEach((git) => {
                            arrGoods.push(git);
                        });
                    }
                });
                pit.arrGoods = arrGoods;
            }
        })
    })
    return objModel
}

/*
    * 商品去重
*/
export function noRepeat(arr) {
    // 第一层for用来控制循环的次数
    for (var i = 0; i < arr.length; i++) {
        //第二层for 用于控制与第一层比较的元素
        for (var j = i + 1; j < arr.length; j++) {
            //如果相等
            if (arr[i].goods_name == arr[j].goods_name) {
                //删除后面的 即第 j个位置上的元素  删除个数 1 个
                arr[i].num = arr[i].num + arr[j].num;
                arr.splice(j, 1);
                // j--很关键的一步  如果删除 程序就会出错
                //j--的原因是 每次使用splice删除元素时 返回的是一个新的数组
                // 这意味这数组下次遍历是 比较市跳过了一个元素
                /*
                例如： 第一次删除后 返回的是 1 1 3 2 1 2 4
             *  但是第二次遍历是 j的值为2  arr[2] = 3
             *  相当于跳过一个元素 因此要 j--
             * */
                j--;
            }
        }
    }
    return arr;
}

/*
    * 给不同系统分类添加商品
*/
export function sort(item, oFloor, arrGoods) {
    switch (item.system_id) {
        case 1:
            oFloor.product.push({
                energy_cold_area:
                oFloor.energy_cold_area,
                temperature:
                oFloor.temperature_design,
                power: oFloor.power,
                energy_cold: oFloor.energy_cold,
                energy_hot: oFloor.energy_hot,
                energy_cold_js:
                oFloor.energy_cold_js,
                energy_hot_js: oFloor.energy_hot_js,
                system_id: item.system_id,
                system_name: "空气能冷暖两联供系统",
                arrGoods: arrGoods,
            });
            break;
        case 2:
            oFloor.product.push({
                water_cold: oFloor.water_cold,
                water_rate: oFloor.water_rate,
                water_energy: oFloor.water_energy,
                system_id: item.system_id,
                system_name: "热水系统",
                arrGoods: arrGoods,
            });
            break;
        case 3:
            oFloor.product.push({
                wind_exchange: oFloor.wind_exchange,
                wind_area: oFloor.wind_area,
                wind_energy: oFloor.wind_energy,
                system_id: item.system_id,
                system_name: "新风系统",
                arrGoods: arrGoods,
            });
            break;
        case 4:
            oFloor.product.push({
                water_clean: oFloor.water_clean,
                water_soft: oFloor.water_soft,
                system_id: item.system_id,
                system_name: "水系统",
                arrGoods: arrGoods,
            });
            break;
    }
    return oFloor
}

/*
    * 初始化选项参数
*/
export function option(pit, oPreUpgrade) {
    if (pit.system_id == 1) {
        pit.energy_cold_area = oPreUpgrade.energy_cold_area;
        pit.temperature = oPreUpgrade.temperature_design;
        pit.power = oPreUpgrade.power;
        pit.energy_cold = oPreUpgrade.energy_cold;
        pit.energy_hot = oPreUpgrade.energy_hot;
        pit.energy_cold_js = oPreUpgrade.energy_cold;
        pit.energy_hot_js = oPreUpgrade.energy_hot;
        pit.arrGoods = noRepeat(pit.arrGoods);
    } else if (pit.system_id == 2) {
        pit.water_cold = oPreUpgrade.water_cold;
        pit.water_rate = oPreUpgrade.water_rate;
        pit.water_energy = oPreUpgrade.water_energy;
        pit.arrGoods = noRepeat(pit.arrGoods);
    } else if (pit.system_id == 3) {
        pit.wind_exchange = oPreUpgrade.wind_exchange;
        pit.wind_area = oPreUpgrade.wind_area;
        pit.wind_energy = oPreUpgrade.wind_energy;
        pit.arrGoods = noRepeat(pit.arrGoods);
    } else if (pit.system_id == 4) {
        pit.water_clean = oPreUpgrade.water_clean;
        pit.water_soft = oPreUpgrade.water_soft;
        pit.arrGoods = noRepeat(pit.arrGoods);
    }
    return pit
}
